<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useMapGetter } from 'dashboard/composables/store';
import { useFandataPerfil } from 'dashboard/composables/useFandataPerfil';
import Button from 'dashboard/components-next/button/Button.vue';
import RetomadaAPI from 'dashboard/api/fandata/retomada';

// T-153 / T-124 — o que fazer quando a janela do canal fecha.
//
// O sistema já avisava que não dá para responder e linkava a política da Meta. Avisar sem oferecer
// saída deixa o agente olhando para a tela: a conversa está lá, o torcedor esperando, e a única
// ação possível é copiar tudo para outro canal na mão.
//
// A investigação do T-124 fechou a pergunta que faltava: no Direct do Instagram NÃO existe
// mensagem iniciada pelo clube nem template pago. A Meta só permite responder quem escreveu, na
// janela de 24 horas (7 dias com a tag Human Agent, T-153c). Ou seja, "envio ativo por Direct como
// no WhatsApp" não existe — e é por isso que o caminho aqui é o e-mail.
const { t } = useI18n();
const currentChat = useMapGetter('getSelectedChat');
const { ehAdmin } = useFandataPerfil();
const enviando = ref(false);

// Só faz sentido no momento exato em que a janela fechou. Botão sempre visível viraria mais um
// item no meio de outros, e o agente não é quem decide contato ativo (T-168).
const mostrar = computed(
  () => ehAdmin.value && currentChat.value && !currentChat.value.can_reply
);

const temEmail = computed(() => Boolean(currentChat.value?.meta?.sender?.email));

const enviar = async () => {
  enviando.value = true;
  try {
    await RetomadaAPI.enviar(currentChat.value.id);
    useAlert(t('FANDATA_SIDEBAR.RETOMADA.ENVIADO'));
  } catch (error) {
    useAlert(
      error?.response?.data?.error || t('FANDATA_SIDEBAR.RETOMADA.ERRO')
    );
  } finally {
    enviando.value = false;
  }
};
</script>

<template>
  <div
    v-if="mostrar"
    class="mx-2 mt-2 flex flex-wrap items-center gap-3 px-4 py-3 rounded-lg border border-n-weak bg-n-solid-1"
  >
    <span class="text-sm text-n-slate-11">
      {{
        temEmail
          ? t('CONVERSATION.RETOMAR.DISPONIVEL')
          : t('CONVERSATION.RETOMAR.SEM_EMAIL')
      }}
    </span>
    <Button
      v-if="temEmail"
      :label="t('CONVERSATION.RETOMAR.BOTAO')"
      icon="i-lucide-mail"
      size="sm"
      variant="faded"
      color="slate"
      class="ml-auto"
      :is-loading="enviando"
      @click="enviar"
    />
  </div>
</template>
